var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal } from 'src/ui/components/modal/Modal';
import { Button, EButtonType } from 'src/ui/components/button/Button';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { COLORS } from 'src/shared/styles/colors';
import styles from 'src/ui/views/users/components/userDetailsModal.module.scss';
export var UserDeleteModal = function (props) {
    var _a;
    var i18n = props.i18n, onCancel = props.onCancel, onValidateClick = props.onValidateClick, keycloakId = props.keycloakId, username = props.username;
    var labelCancelButton = getPropsByKeyPath(i18n, 'components.deleteUserModal.cancelButtonLabel');
    var labelValidateButton = getPropsByKeyPath(i18n, 'components.deleteUserModal.confirmButtonLabel');
    var modalTitle = (_a = getPropsByKeyPath(i18n, 'components.deleteUserModal.title')) === null || _a === void 0 ? void 0 : _a.replace('$username', username);
    var description = getPropsByKeyPath(i18n, 'components.deleteUserModal.message');
    var handleValidateClick = function () {
        // @ts-ignore
        onValidateClick({ username: username, keycloakId: keycloakId });
    };
    return (_jsxs(Modal, __assign({ title: modalTitle, onClose: onCancel, color: COLORS.RED['500'] }, { children: [_jsx("p", { children: description }), _jsxs("div", __assign({ className: styles.actionsWrapper }, { children: [_jsx(Button, { isEdge: true, type: EButtonType.ABORT, label: labelCancelButton, classname: styles.button, onClick: onCancel }), _jsx(Button, { type: EButtonType.ABORT, label: labelValidateButton, classname: styles.button, onClick: handleValidateClick })] }))] })));
};
